module.exports = " <div class=component-grid> <div class=container-grid> <div class=row-grid> <div class=column-grid v-for=\"n in columns\"> <div class=gutter></div> </div> </div> </div> <input type=number slot=right v-model=columns number> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid.vue
// module id = 739
// module chunks = 2